import { isFinite } from 'lodash';

export default function Currency({ quantity }) {
    if (!isFinite(quantity)) return null;
    //return `${quantity.toFixed(2).replace('.', ',')} €`;
    // dot as a thousend separator
    return `${quantity.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')} €`;
}
